export const SELF_EVAL_REVIEW_KEY = '__hss_review_submitted_at';

export function selfEvalReviewIsComplete(response) {
  return !!(
    response?.instructor_comment?.[SELF_EVAL_REVIEW_KEY] ||
    String(response?.final_grade || '').trim()
  );
}

export function selfEvalCompleteGradeLabel(response) {
  const grade = String(response?.final_grade || '').trim();
  return 'Complete ' + (grade || '-');
}
